import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {connect} from 'react-redux'
import actions from 'redux-auto'
import DialogLogic from '../Flyout/DialogLogic'
import DateRangePicker from '#components/m/DateRangePicker'
import Button from '#components/a/Button'
import TerminTypeInput from './TerminTypeInput'
import DialogDeleteIcon from './DialogDeleteIcon'
import {TerminAzubiHintBox} from './TerminAzubiHintBox'
import ControlsGroup from '#components/m/ControlsGroup'
import {format} from 'ag-common/facades'

export class TerminEditDialog extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      subject: props.subject,
      datePickerStart: this.props.from,
      datePickerEnd: this.props.to,
      conflictExists: this.getConflictExists(this.props.from, this.props.to),
    }
  }

  getConflictExists = (from, to) => {
    const {termine} = this.props
    return DialogLogic.doesConflictExist(
      from,
      to,
      termine.filter(t => t.id !== this.props.id),
    )
  }

  onTerminTypeChanged = subject => {
    this.setState({
      subject,
    })
  }

  onDateRangeChanged = (start, end) => {
    this.setState({
      datePickerStart: start,
      datePickerEnd: end,
      conflictExists: this.getConflictExists(start, end),
    })
  }

  closeDialog = evt => {
    const {closed} = this.props
    closed(evt)
  }

  onSubmit = () => {
    this.props.updateTermin({
      id: this.props.id,
      subject: this.state.subject,
      from: format(this.state.datePickerStart, 'yyyy-MM-dd'),
      to: format(this.state.datePickerEnd, 'yyyy-MM-dd'),
    })
    this.closeDialog()
  }

  onDeleteTermin = () => {
    this.props.deleteTermin({terminId: this.props.id})
  }

  render() {
    const {datePickerStart, datePickerEnd, subject, conflictExists} = this.state

    return (
      <div className="terminEditDialog">
        <DialogDeleteIcon id={this.props.id} onConfirm={this.onDeleteTermin} type="termin" />
        <TerminTypeInput initialSubject={subject} onTerminTypeChanged={this.onTerminTypeChanged} />
        <DateRangePicker
          initialStartDate={datePickerStart}
          initialEndDate={datePickerEnd}
          onRangeUpdated={this.onDateRangeChanged}
        />
        <TerminAzubiHintBox conflictExists={conflictExists} potentialTermineCount={1} />
        <ControlsGroup>
          <Button variant="secondarydark" text={i18n.t('misc_cancel')} event={this.closeDialog} />
          <Button
            variant="primarydark"
            text={i18n.t('misc_save')}
            disabled={conflictExists.ausbilderTerminConflict}
            event={this.onSubmit}
          />
        </ControlsGroup>
      </div>
    )
  }
}

function mapDispatchToProps() {
  return {
    deleteTermin: actions.versetzungsplan.deleteTermin,
    updateTermin: actions.versetzungsplan.updateTermin,
  }
}

export default connect(mapDispatchToProps)(TerminEditDialog)

TerminEditDialog.propTypes = {
  deleteTermin: PropTypes.func,
  updateTermin: PropTypes.func,
  closed: PropTypes.func,
  subject: PropTypes.string,
  id: PropTypes.string,
  from: PropTypes.instanceOf(Date),
  to: PropTypes.instanceOf(Date),
  termine: PropTypes.arrayOf(PropTypes.object),
}
